import $api from '../services';

export default {
    downloadTemplate() {
        return $api.get('/profile/business/download-xls?withData=false', null, {
            responseType: 'blob'
        });
    },
    exportUsers(params) {
        return $api.get('/profile/business/download-xls?withData=true', null, {
            params,
            responseType: 'blob'
        });
    },
    importUsers(data) {
        return $api.post('/profile/business/upload-xls', data, {
            timeout: 120000
        });
    },
    updateFields(params) {
        return $api.put('/custom-fields', params);
    },
    createFields(params) {
        params.items.map(item => {
            const { id, label, type, isRequired } = item;
            return { id, label, type, isRequired };
        });
        return $api.post('/custom-fields', params);
    },
    readFields(id) {
        if (id) {
            return $api.get('/custom-fields?businessId=' + id);
        }
        return $api.get('/custom-fields');
    }
};
